import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { AnalyticsHelpers } from '../../analytics.helpers';
import { getAnalyticsDatePeriod, getAnalyticsFilter } from '../../../../store/features/analytics';
export const NoMeetingHistory = () => {
    const cn = AnalyticsHelpers.makeMeetingHistoryClass('block');
    const datePeriod = useSelector(getAnalyticsDatePeriod);
    const { providersIds, roomsIds, locationIds } = useSelector(getAnalyticsFilter);
    const [messageData, setMessageData] = useState(AnalyticsHelpers.getNoDataMessage(datePeriod, providersIds, roomsIds, locationIds));
    useEffect(() => {
        setMessageData(AnalyticsHelpers.getNoDataMessage(datePeriod, providersIds, roomsIds, locationIds));
    }, [datePeriod, providersIds, roomsIds, locationIds]);
    return (<div className={cn('no-content-wrapper')}>
      <h2 className={cn('no-content-header')}>
        <FormattedMessage id={messageData.titleKey}/>
      </h2>
      <p className={cn('no-content-text')}>
        <FormattedMessage id={messageData.messageKey} values={{
            InfoLink: (<>
                <br />
                <a target="_blank" href="https://help.doxy.me/en/articles/95870-invite-share-a-link-to-your-waiting-room">
                  <FormattedMessage id="account.meeting-history.no-meeting-history.invite"/>
                </a>
              </>)
        }}/>
      </p>
    </div>);
};
